import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'fleet', pathMatch: 'full' },
  {
    path: 'fleet',
    canActivate: [authGuard],
    loadComponent: () => import('./features/fleet/fleet.component').then(m => m.FleetComponent)
  },
  {
    path: 'fleet/:id',
    canActivate: [authGuard],
    loadComponent: () => import('./features/fleet/fleet-detail/fleet-detail.component').then(m => m.FleetDetailComponent)
  },
  {
    path: 'reports',
    canActivate: [authGuard],
    loadComponent: () => import('./features/reports/reports.component').then(m => m.ReportsComponent)
  },
  {
    path: 'administration',
    // Deliberately open to every role: a read-only user can read their organization's users, and the
    // page renders without its write controls rather than being taken away. See `core/permissions.ts`.
    canActivate: [authGuard],
    loadComponent: () => import('./features/admin/admin.component').then(m => m.AdminComponent)
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent)
  },
  // The wildcard must stay last — any route after it is unreachable.
  { path: '**', redirectTo: 'fleet' }
];
